import { z } from "zod";
import { adminCountSchema, adminPageQuerySchema } from "./common.js";
export const auditQuerySchema = adminPageQuerySchema;
/** What operators changed, and who did it. */
export const adminAuditSchema = z.object({
    asOf: z.string(),
    total: adminCountSchema,
    rows: z.array(z.object({
        id: z.string(),
        at: z.string(),
        actor: z.string(),
        action: z.string(),
        target: z.string(),
        detail: z.string(),
    })),
});
//# sourceMappingURL=audit.js.map